import router from '@/router'
import Pub from '@/utils/public'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { userMenusPermissions } from '@/api/request'
import { message } from 'ant-design-vue'

// 白名单
const whiteList = ['/login', '/check', '/summary-data']

// 权限列表
var permissions = []

// 首页白名单
let whiteListPro = [
  '/summary-data',
  '/home',
]
// 内部账户使用 - 项目管理
if (Pub.IS_DEBUG() || Pub.IS_SPECIAL_UIDS()) {
  whiteListPro = whiteListPro.concat([
    // '/project',
  ])
}

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否有权限列表
  if (permissions.length || !Pub.ACCESS_TOKEN()) {
    // 继续
    beforeEachHandler(to, from, next)
  } else {
    // 请求权限列表
    getuserMenusPermissions((isOK) => {
      // 继续
      beforeEachHandler(to, from, next)
    })
  }
})

// 跳转处理
function beforeEachHandler(to, from, next) {
  // title
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`))
  // 默认
  // next()
  // 检查是否有 Token
  if (Pub.ACCESS_TOKEN()) {
    // 判断权限
    if (!Pub.isCheckAuth || permissions.includes(to.path) || whiteListPro.includes(to.path)) {
      // 有权限，继续
      next()
    } else {
      // 非首页
      if (to.path !== '/') {
        // 提示
        message.error('暂无访问权限')
      }
      // 无权限，进首页
      next({ path: '/home' })
    }
  } else {
    // 没有 Token，检查白名单
    if (whiteList.includes(to.path)) {
      // 属于白名单则继续下一步
      next()
    } else {
      // 不属于白名单则进入登录页面（redirect 值可作为登录成功后跳转的地址，帮助用户进入指定页面）
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }
}

// 获取权限列表
function getuserMenusPermissions(result) {
  // 请求权限
  userMenusPermissions().then(res => {
    const { code, data } = res
    if (code === 0) {
      // 记录权限
      permissions = data.permissions
    }
    if (result) { result(code === 0) }
  }).catch(() => {
    if (result) { result(false) }
  })
}